export function TimeKeepingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/time-keeping.svg'"></ng-include>`
    }
}
            